import React from 'react';
import classNames from 'classnames';
import './HelpText.pcss';

type Props = {
  className?: string;
  text?: string | JSX.Element | Element;
  title?: string;
  children?: string[] | string | Element[] | JSX.Element | Element;
  size?: 's' | 'sm' | 'm';
};

export const HelpText = ({ className, size, text, title, children }: Props) => {
  return (
    <span
      className={classNames(className, 'c-help-text', {
        'c-help-text--s': size === 's',
        'c-help-text--sm': size === 'sm',
        'c-help-text--m': size === 'm',
      })}
      title={title}
    >
      {text || children}
    </span>
  );
};
